import * as React from 'react';
import { observer } from 'mobx-react';
import { WorkflowConfiguration } from 'nomst/Stores/Configuration/workflowConfiguration';
import { WorkflowRulesSection } from 'nomst/Components/WorkflowSettings/workflowRulesSection';
import WorkflowPreview from 'nomst/Components/WorkflowSettings/workflowPreview';

export interface IWorkflowConfigurationViewProps {
    workflowConfiguration: WorkflowConfiguration;
    readonly?: boolean;
}

interface IWorkflowConfigurationViewState {
    workflowRows: Nullable<string[][]>;
}

export class WorkflowConfigurationView
    extends React.Component<IWorkflowConfigurationViewProps, IWorkflowConfigurationViewState> {
    constructor(props: IWorkflowConfigurationViewProps) {
        super(props);
        this.state = {
            workflowRows: null
        };

        this.updateWorkflowRows = this.updateWorkflowRows.bind(this);
    }

    async componentDidMount(): Promise<void> {
        const { workflowConfiguration } = this.props;
        await Promise.all([
            workflowConfiguration.setDivisionDepartmentBusinessUnitAvailability(),
            this.updateWorkflowRows()]);
    }

    render(): React.ReactNode {
        const { workflowConfiguration, readonly } = this.props;
        return (
            <>
                <WorkflowRulesSection
                    workflowConfiguration={workflowConfiguration}
                    updatePreviewCallback={this.updateWorkflowRows}
                    readonly={readonly}
                />
                <WorkflowPreview
                    workflowRows={this.state.workflowRows}
                />
            </>
        );
    }

    private async updateWorkflowRows(): Promise<void> {
        const { workflowConfiguration } = this.props;
        this.setState({ workflowRows: null });
        const details = await workflowConfiguration.getWorkflowDetails();
        this.setState({ workflowRows: details });
    }
}

export default observer(WorkflowConfigurationView);